export default "__VITE_ASSET__efkOhcUr__"